const logout = () => {
  document.addEventListener("DOMContentLoaded", function() {

    const logoutBtn = document.querySelectorAll('.logout-btn');

    if (!logoutBtn.length) {
      return;
    }

    logoutBtn.forEach(function(button) {

      button.addEventListener('click', function() {

        jQuery.ajax({
          url: rcData.ajaxUrl,
          type: 'post',
          data: {
            action: 'handle_logout_by_type',
          },
          success: function (response) {


            if (response.success && response.data.redirect_link) {
              window.location.href = response.data.redirect_link;
            }

          },
          error: function (error) {
            console.error('AJAX error:', error);
          },
        });

      });

    });

  });
};

export default logout;
